import React from "react"
import dataLayerHelper from "../../helpers/datalayer.helper"
import ButtonLink from "../btn-collections/btn-collections.component"
import TrustPilotGeneralLightTheme from "../trust-pilot/trust-pilot-general-light-theme.component"
import PinkCheckmark from "../../svg/pink-checkmark.svg"
import { GatsbyImage } from "gatsby-plugin-image"
import { getImage } from "gatsby-plugin-image"

import {
  PageHeroButtonContainer,
  LongHeader,
  PageHeader,
  CircularImageWrapper,
  AvatarImages,
  TopCopyContainer,
  HeaderBulletsContainer,
  HeaderBullets,
  ShortBulletsContainer,
  AvatarFlexContainer,
  FlexContainer,
  PageHeroStraplineGrid,
  BottomContentContainer,
  ExploreCoursesButton,
  TrustPilotContainer,
} from "./page-hero-strapline.styles"

const PageHeroStrapline = ({ data, location, topCopy, studentAvatars }) => {
  const {
    link_url,
    link_text,
    button_text,
    button_url,
  } = data

  const longCopy = [
    "27 roadmaps to get into a $200,000+/year career",
    "Get ahead & level up by working with the latest AI tools",
    "Master top skills for 2026 with our up-to-date courses",
    "Stand out by building epic real-world projects",
    "Get help when you need it from industry experts & alumni"
  ]

  const shortCopy = [
    "Roadmap to get a $200K+/year career",
    "Get ahead & learn the latest AI tools",
    "Master the top skills for 2026",
    "Stand out with real-world projects",
    "Get support from industry experts"
  ]

  return (
    <PageHeroStraplineGrid>
      <AvatarFlexContainer>
        <div style={{ display: "flex" }}>
        {studentAvatars.map((avatar, index) => {
          const image = getImage(avatar.gatsbyImageData || avatar);
          return (
            <AvatarImages 
              key={index}
              image={image} 
              alt={`Student ${index}`}
              style={{ borderRadius: "50%", width: "50px", height: "50px" }} 
            />
          );
        })}
      </div>
        <TopCopyContainer dangerouslySetInnerHTML={{ __html: topCopy, }} />
      </AvatarFlexContainer>
      <PageHeader>Learn the skills to stand out <span>in the age of AI.</span></PageHeader>
      <LongHeader>Learn the skills to stand out & get hired. <span>In the age of AI.</span></LongHeader>
      {longCopy.length > 0 && (
        <HeaderBulletsContainer>
          {longCopy.map((bullet, index) => (
            <FlexContainer key={index}>
              <PinkCheckmark style={{ marginRight: "15px", flexShrink: "0" }} />
              <HeaderBullets>{bullet}</HeaderBullets>
            </FlexContainer>
          ))}
        </HeaderBulletsContainer>
      )}

      {shortCopy.length > 0 && (
        <ShortBulletsContainer>
          {shortCopy.map((bullet, index) => (
            <FlexContainer key={index}>
              <PinkCheckmark style={{ marginRight: "15px", flexShrink: "0" }} />
              <HeaderBullets>{bullet}</HeaderBullets>
            </FlexContainer>
          ))}
        </ShortBulletsContainer>
      )}
      <BottomContentContainer>
        <PageHeroButtonContainer>
          <ExploreCoursesButton
            tabIndex={0}
            aria-label="Explore over 170 courses"
            mediumSquareSecondary
            internal
            url={button_url}

            onClick={() =>
              dataLayerHelper({
                event: "revolvingStraplineButtonClicks",
                label: `${location}-Primary`,
              })
            }
          >
            EXPLORE 170+ COURSES
          </ExploreCoursesButton>
          <ButtonLink
            tabIndex={0}
            aria-label="Start your career path"
            mediumSquare
            internal
            url='/career-paths/'
            onClick={() =>
              dataLayerHelper({
                event: "revolvingStraplineButtonClicks",
                label: `${location}-Primary`,
              })
            }
          >
            START YOUR CAREER PATH
          </ButtonLink>
        </PageHeroButtonContainer>
        <TrustPilotContainer>
          <TrustPilotGeneralLightTheme />
        </TrustPilotContainer>
      </BottomContentContainer>
    </PageHeroStraplineGrid>

  )
}

export default PageHeroStrapline
